import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { IconSharedModule } from './../../atoms/entry';
import { SubNavHorizontalSharedComponent } from './sub.nav.horizontal.component';

@NgModule({
    declarations: [
        SubNavHorizontalSharedComponent
    ],
    imports: [
        CommonModule,
        RouterModule.forChild([]),
        IconSharedModule
    ],
    exports: [
        SubNavHorizontalSharedComponent
    ]
})

export class SubNavHorizontalSharedModule {}
